module.exports = __webpack_public_path__ + "static/media/msg.211d8ea7.png";